import Phaser, { GameObjects } from 'phaser'
import '../../characters/Thief'
import Thief from "../../characters/Thief"
import {createThiefAnimations} from "../../animations/ThiefAnimation"
import {sceneEvents} from "../../events/EventsCenter"
import {Hints, hints} from "../../assets/classes/Hints"
import {Karten, karten } from "../../assets/classes/Karten"
import QuestionLoader from '../../assets/classes/QuestionLoader'
import TilesetManager from '../../scenes/Levels/TilesetManager'

var keyM
export default class Level1 extends Phaser.Scene {
    // Variablen belegen
    private thief!: Thief
    private hintNum!: number
    private karte: Karten = new Karten(1)
    private karten: Karte[] = this.karte.getKarten()
    private kartenNum!: number
    private tilesetManager!: TilesetManager

    private questionText!: string;
    private options!: string[];
    private explanation!: string;
    private randomQuestion: any;
    private rightAnswer: any;
    private questionId!: number;

    constructor() {
        // Variablen vorbelegen
        super('level1')
        //randomQuestion.done = true
        this.hintNum = 1
        this.kartenNum = 0
    }

    create() {
        // Kameraführung
        this.cameras.main.fadeIn(500)

        if (this.hintNum == 1) {
            this.scene.launch('hints', {
                content: hints[1].content
            })
        }
      
        // Animationen erzeugen
        createThiefAnimations(this.anims)
      
        const map = this.make.tilemap({key: 'map1'})
      
        // Tilesets hinzufügen
        this.tilesetManager = new TilesetManager(this);
        const allLayers = this.tilesetManager.loadTilesets(map, 'otherLevel');
        
        // Gebäude, Mauern und Objekte zu Layern hinzufügen
        map.createLayer(0, allLayers)
        const gebaeude = map.createLayer(1, allLayers)
        const gebaeudeMauer = map.createLayer(2, allLayers)
        const objekte = map.createLayer(3, allLayers)
      
        // Thief erzeugen
        this.thief = this.add.thief(1750, 1700, 'thief')
        if(this.thief?.body){
            this.thief.body.offset.y = 16
        }
        
        // Kollission
        objekte?.setCollisionByExclusion([-1])
        gebaeudeMauer?.setCollisionByExclusion([-1])
        gebaeude?.setCollisionByExclusion([-1])

        //QuestionLoader
        const questionLoader = new QuestionLoader();

        questionLoader.loadQuestion(1).then(questionData => {
          this.questionText = questionData.questionText;
          this.options = questionData.options;
          this.randomQuestion = questionData;
          this.rightAnswer = questionData.rightAnswer;
          this.explanation = questionData.explanation;
          this.questionId = questionData.questionId;
    
          const hints = questionData.hints;
        });

  
        //Tasten belegen für Musiksteuerung
        if(this.input?.keyboard){
            keyM = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.M)
        }

        this.cameras.main.startFollow(this.thief, true)

        // Rectangle über Türe legen, damit Thief damit colliden kann
        var door = this.add.rectangle(1820, 850, 200, 100)
        this.physics.add.existing(door, true)

        // Collider hinzufügen
        if(objekte) this.physics.add.collider(this.thief, objekte)
        if(gebaeudeMauer) this.physics.add.collider(this.thief, gebaeudeMauer)
        if(gebaeude)this.physics.add.collider(this.thief, gebaeude)
        this.physics.add.collider(this.thief, door, this.handleThiefDoorCollision, undefined, this)


        //Steuerung
            this.scene.launch('joystickTouch', {
                thief: this.thief
            });

        //PausenButton erstellen
        this.scene.launch('pausenButton', {
            pausedSceneKey: this.scene.key
        })

        //MapButton erstellen
        this.scene.launch('mapButton')

        //MusikButton erstellen
        this.scene.launch('musikButton')

        // Ruft Stoppuhr auf
        this.scene.launch('stopwatchscene')

        // walkietalkie
        this.scene.launch('equipment')

        // Nächstes Level aufrufen
        this.events.on('resume', (sys, data) => {
            if (data.caller === 'pausenButton') {
                this.hintNum = 1
                this.kartenNum = 0
            } else {
                if (data.bool && data.caller === 'questionScene') {
                    this.scene.stop()
                    this.scene.start('level9')
                } else {
                    this.hintNum = 1
                    this.kartenNum = 0
                    this.scene.stop()
                    this.scene.start()
                }
            }
        })

        // Hinweise anzeigen
        sceneEvents.on('getHint', () => {
            if (this.scene.isActive('karten')) {
                this.scene.setVisible(false, 'karten')
            }

            this.scene.launch('hints', {
                content: hints[this.hintNum].content
            })
        })

        //Karten anzeigen
        sceneEvents.on('getKarten', () => {
            if (this.scene.isActive('hints')) {
                this.scene.setVisible(false, 'hints')
                this.scene.launch('equipment')
            }

            this.scene.launch('karten', {
                content: this.karten[0].content
            })
        })
    }


    handleThiefDoorCollision() {
        this.thief.setQuestion();
        sceneEvents.once('openQuestion', () => {
            this.scene.pause()
            this.scene.stop('mapButton')
            this.scene.stop('karten')
            this.scene.stop('joystickTouch')
            // Wiederverwendbare Szene mit Parametern aufrufen
            this.scene.launch('questionScene', {
                question: this.questionText,
                answer1: this.options[0],
                answer2: this.options[1],
                answer3: this.options[2],
                rightAnswer: this.rightAnswer,
                explanation: this.explanation,
                caller: 'level1'
            })
        })

    }

}

